<template lang="pug">

    form.ui.form(v-on:submit.prevent="submit()")

        //- Step-Navigation
        step-navigation(v-bind:step='3')

        //- Formular

        //- Benutzerinformation
        .ui.top.attached.header Benutzerinformation:
        .ui.bottom.attached.segment
            general-information-form(
                ref="generalInformationForm"
                v-model="user"
            )

        //- Personendaten
        .ui.top.attached.header Personendaten:
        .ui.bottom.attached.segment
            person-form(
                ref="personForm"
                v-model="person"
                v-bind:hideAddress="true"
                v-bind:hideCompany="true"
            )

        //- Rollen
        .ui.top.attached.header Rollen:
        .ui.bottom.attached.segment
            role-form(
                ref="roleForm"
                v-bind:companyModel="model"
                v-model="user"
            )


        .ui.two.columns.grid
            .left.aligned.column
                router-link.ui.labeled.icon.button(v-bind:to='{ name: "companies/create/step2" }' exact)
                    i.chevron.left.icon
                    |  Zurück
            .right.aligned.column
                a.ui.labeled.icon.button(v-on:click='cancel()')
                    i.remove.icon
                    |  Abbrechen
                button.ui.right.labeled.primary.icon.button
                    i.checkmark.icon
                    |  Speichern

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import GeneralInformationForm from '@/components/users/GeneralInformationForm.vue'
    import PersonForm from '@/components/persons/Form.vue'
    import RoleForm from '@/components/users/RoleForm.vue'
    import StepNavigation from '@/components/companies/StepNavigation.vue'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {
        name: 'companies-create-step3-view',

        components: { GeneralInformationForm, PersonForm, RoleForm, StepNavigation },

        computed: {

            company() {
                return this.model
            },

            isInvalid() {
                return this.$refs.generalInformationForm.isInvalid ||
                    this.$refs.personForm.isInvalid ||
                    this.$refs.roleForm.isInvalid
            },

            model: {
                get() { return this.$store.getters['companies/draft'] },
                set(value) { this.$store.commit('companies/REPLACE_DRAFT', { draft: value }) }
            },

            person: {
                get() { return this.model.person || {} },
                set(value) { this.model = { ...this.model, person: value } }
            },

            user: {
                get() { return this.model.user || {} },
                set(value) { this.model = { ...this.model, user: value } }
            }

        },

        created() {
            this.$scrollTo('body')
        },

        methods: {
            cancel() {
                this.$router.push({ name: 'companies' })
            },

            submit() {
                // Benutzer-Model und Personen-Model zusammenführen
                const user = R.merge(this.model.person, this.model.user)

                // Model speichern
                const model = R.compose(

                    // Person entfernen
                    // > { person: { firstName: "foo" }, user: { firstName: "foo", username: "bar" } }
                    // < { user: { firstName: "foo", username: "bar" } }
                    R.dissoc('person'),

                    // Zusammengeführten Benutzer setzen
                    // > { person: { firstName: "foo" }, user: { username: "bar" } }
                    // < { person: { firstName: "foo" }, user: { firstName: "foo", username: "bar" } }
                    R.assoc('user', user)

                )(this.model)

                // Speichern
                return this.validate()
                    .then(() => store.dispatch('companies/create', { model }))
                    .then(() => this.$growl.success('Unternehmen wurde erstellt'))
                    .then(() => this.$router.push({ name: 'companies' }))
                    .catch(e => this.$growl.fatal('Unternehmen konnte nicht gespeichert werden', e))
            },

            validate() {
                return Promise.all([
                    this.$refs.generalInformationForm.validate(),
                    this.$refs.personForm.validate(),
                    this.$refs.roleForm.validate()
                ])
            }
        },

    }

</script>
